import { AxiosHeaders, Method, RawAxiosRequestHeaders } from "axios";
import { config } from "../environment"
import axiosInstance from "./interceptor"


type HeaderType = (RawAxiosRequestHeaders & (Partial<{ [Key in Method as Lowercase<Key>]: AxiosHeaders; } & { common: AxiosHeaders }>)) | AxiosHeaders
class httpRoutingService {

    convertQS(params: any, prefix?: string, includeNull?: true): string {
        const query = Object.keys(params)
            .filter(key => includeNull || params[key] !== null)
            .map(key => {
                const value = params[key];
                const encodedKey = prefix ? `${prefix}[${encodeURIComponent(key)}]` : encodeURIComponent(key);

                if (value !== null && typeof value === "object" && !(value instanceof Date)) {
                    if (Array.isArray(value)) {
                        return value
                            .map(item => `${encodedKey}=${encodeURIComponent(item)}`)
                            .join("&");
                    } else {
                        return this.convertQS(value, encodedKey, includeNull);
                    }
                } else {
                    return `${encodedKey}=${value === null ? "null" : encodeURIComponent(value)}`;
                }
            })
            .join("&");

        return query ? `?${query}` : "";
    }

    getMethod<T>(url: string, params?: any, urlVersion?: "v1/" | "v2/", includeNull?: true, headers?: HeaderType): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v2/') + url
        console.log("Get method ->", finalUrl + (params ? this.convertQS(params, "", includeNull) : ""))
        return axiosInstance.get<T>(finalUrl + (params ? this.convertQS(params, "", includeNull) : ""), { headers }) as Promise<T>

    }

    putMethod<T>(url: string, data?: any, queryParams?: any, urlVersion?: "v1/" | "v2/", headers?: HeaderType): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v1/') + url
        console.log("Put method ->", finalUrl, data ? data : "", queryParams ? queryParams : "");
        return axiosInstance.put<T>(finalUrl, data, { params: queryParams, headers }) as Promise<T>
    }

    patchMethod<T>(url: string, data?: any, queryParams?: any, urlVersion?: "v1/" | "v2/", headers?: HeaderType): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v1/') + url
        console.log("Patch method ->", finalUrl, data ? data : "", queryParams ? queryParams : "");
        return axiosInstance.patch<T>(finalUrl, data, { params: queryParams, headers }) as Promise<T>
    }

    postMethod<T>(url: string, data?: any, queryParams?: any, urlVersion?: "v1/" | "v2/", headers?: HeaderType): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v1/') + url
        console.log("Post method ->", finalUrl, data ? data : "", queryParams ? queryParams : "");
        return axiosInstance.post<T>(finalUrl, data, { params: queryParams, headers }) as Promise<T>
    }

    deleteMethod<T>(url: string, queryParams?: any, urlVersion?: "v1/" | "v2/"): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v1/') + url
        console.log("Delete method ->", finalUrl, queryParams ? queryParams : "");
        return axiosInstance.delete<T>(finalUrl, { params: queryParams }) as Promise<T>
    }

    bulkDeleteMethod<T>(url: string, body?: any, urlVersion?: "v1/" | "v2/"): Promise<T> {
        let finalUrl = config?.apiUrldb + (urlVersion ? urlVersion : 'v1/') + url
        console.log(" Bulk delete method ->", finalUrl, body ? body : "");
        return axiosInstance.delete<T>(finalUrl, { data: body }) as Promise<T>
    }

    replaceUrl(url: string, replaceValues: any) {
        for (const key in replaceValues) {
            url = url.replace('{' + key + '}', replaceValues[key]);
        }
        return url;
    }
}

const HttpRoutingService = new httpRoutingService()
export default HttpRoutingService